import type {z} from "zod";

import {ContactInputFields, PhoneNumberInput} from "@project/sdk/sales/zod";
import {z as zod} from "zod";

import {requiredStringSchema} from "../../../../../../../shared/validation/required-string.schema";
import {contactFieldLabelIds} from "../../../../../../../support/messages/contact.messages";

const contactInputFields = ContactInputFields.shape;

export const editLeadContactNameSchema = requiredStringSchema(
  contactInputFields.name,
  contactFieldLabelIds.name,
);
export const editLeadContactEmailSchema = contactInputFields.email.or(zod.literal(""));

const editLeadContactFormFieldsSchema = zod.object({
  name: editLeadContactNameSchema,
  description: contactInputFields.description,
  email: editLeadContactEmailSchema,
  phone: PhoneNumberInput.shape.nationalNumber.optional(),
  phonePrefix: PhoneNumberInput.shape.regionCode.optional(),
});

export const editLeadContactFormSchema = editLeadContactFormFieldsSchema.superRefine(
  (value, ctx) => {
    if (!value.email && !value.phone) {
      ctx.addIssue({code: "custom", message: "Email or phone is required", path: ["email"]});
    }

    if (value.phone && !value.phonePrefix) {
      ctx.addIssue({
        code: "custom",
        message: "Phone prefix is required",
        path: ["phonePrefix"],
      });
    }
  },
);
export type EditLeadContactFormPayload = z.output<typeof editLeadContactFormSchema>;

export const draftEditLeadContactFormSchema = editLeadContactFormFieldsSchema.partial();
export type DraftEditLeadContactFormPayload = z.output<typeof draftEditLeadContactFormSchema>;
